import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'kt-formly-wrapper-label-tooltip',
    styles: [
        ':host { display: block; margin-bottom: 1rem; }',
        '::ng-deep .label-tooltip { white-space: pre-line; }',
    ],
    template: `
  <div [style.display]="'flex'"
       [style.align-items]="'center'"
       [style.gap.px]="0"
       [style.padding-bottom.px]="props['hideWrapperLabel'] ? 10 : 0"
       [style.padding-left.px]="props['hideWrapperLabel'] ? 10 : 0">

    @if(!props['hideWrapperLabel']) {
    <label>
      {{ props['wrapperLabel'] ?? props.label }}
      @if(props.required) {<span>*</span>}
    </label>
    }
    @if(props['hideWrapperLabel']) {
      <ng-container #fieldComponent />
    }

    <mat-icon [style.font-size.rem]="1.2"
              [style.margin-left.px]="5"
              [matTooltip]="props['labelTooltip']"
              matTooltipPosition="above"
              matTooltipClass="label-tooltip">info</mat-icon>

  </div>
  @if(!props['hideWrapperLabel']) {
  <ng-container #fieldComponent />
  }
`,
    standalone: false
})
export class FormlyWrapperLabelTooltipComponent extends FieldWrapper { }
